import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { authUpdateProfile, authChangePassword, formatApiError } from "@/lib/api";
import { PageHeader, Field, Card, SaveBar } from "./_shared";
import PushSettings from "@/components/PushSettings";
import { capitalizeName } from "@/lib/text";

export default function Profil() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({
    prenom: user?.prenom || "",
    nom: user?.nom || "",
    phone: user?.phone || "",
    type_evenement: user?.type_evenement || "",
    adresse: user?.adresse || "",
    code_postal: user?.code_postal || "",
    ville: user?.ville || "",
  });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const pwd = useState({ current: "", next: "", confirm: "" });
  const [pwdForm, setPwdForm] = pwd;
  const [pwdMsg, setPwdMsg] = useState("");
  const [pwdErr, setPwdErr] = useState("");
  const [pwdSaving, setPwdSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setMsg(""); setErr(""); setSaving(true);
    // Force-capitalize names on submit (in case the browser autofilled lowercase)
    const cleaned = {
      ...form,
      prenom: capitalizeName(form.prenom),
      nom: capitalizeName(form.nom),
      ville: capitalizeName(form.ville),
    };
    try {
      const updated = await authUpdateProfile(cleaned);
      setUser(updated);
      setForm((f) => ({ ...f, ...cleaned }));
      setMsg("Profil mis à jour.");
    } catch (e2) { setErr(formatApiError(e2)); }
    finally { setSaving(false); }
  };

  const changePwd = async (e) => {
    e.preventDefault();
    setPwdMsg(""); setPwdErr("");
    if (pwdForm.next !== pwdForm.confirm) { setPwdErr("Les mots de passe ne correspondent pas."); return; }
    if (pwdForm.next.length < 6) { setPwdErr("6 caractères minimum."); return; }
    setPwdSaving(true);
    try {
      await authChangePassword(pwdForm.current, pwdForm.next);
      setPwdForm({ current: "", next: "", confirm: "" });
      setPwdMsg("Mot de passe modifié.");
    } catch (e2) { setPwdErr(formatApiError(e2)); }
    finally { setPwdSaving(false); }
  };

  return (
    <div data-testid="ec-profil">
      <PageHeader
        eyebrow="Mon compte"
        title="Détails"
        italic="du compte."
        desc="Vos coordonnées sont utilisées pour préparer votre événement et vous tenir informé."
      />

      <Card className="mb-8">
        <form onSubmit={save} className="space-y-5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <Field label="Prénom *" value={form.prenom} onChange={(v) => setForm({ ...form, prenom: capitalizeName(v) })} testid="profil-prenom" required />
            <Field label="Nom *" value={form.nom} onChange={(v) => setForm({ ...form, nom: capitalizeName(v) })} testid="profil-nom" required />
          </div>
          <Field label="Téléphone *" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} testid="profil-phone" required />
          <Field label="Email" value={user?.email} onChange={() => {}} testid="profil-email" />
          <p className="text-[11px] text-white/40 -mt-3">L&apos;email ne peut pas être modifié. Contactez-nous si besoin.</p>
          <Field label="Adresse postale *" value={form.adresse} onChange={(v) => setForm({ ...form, adresse: v })} testid="profil-adresse" placeholder="12 rue des Lilas" required />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <Field label="Code postal *" value={form.code_postal} onChange={(v) => setForm({ ...form, code_postal: v })} testid="profil-cp" placeholder="59000" required />
            <div className="md:col-span-2">
              <Field label="Ville *" value={form.ville} onChange={(v) => setForm({ ...form, ville: capitalizeName(v) })} testid="profil-ville" placeholder="Lille" required />
            </div>
          </div>
          <Field label="Type d&apos;événement" value={form.type_evenement} onChange={(v) => setForm({ ...form, type_evenement: v })} testid="profil-evt" placeholder="Mariage, anniversaire…" />
          {err && <p className="text-xs text-red-300">{err}</p>}
          <SaveBar saving={saving} message={msg} />
        </form>
      </Card>

      <Card>
        <h2 className="font-serif-luxe text-2xl mb-1">Changer mon mot de passe</h2>
        <p className="text-xs text-white/55 mb-5">6 caractères minimum.</p>
        <form onSubmit={changePwd} className="space-y-5">
          <Field type="password" label="Mot de passe actuel" value={pwdForm.current} onChange={(v) => setPwdForm({ ...pwdForm, current: v })} testid="pwd-current" required />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <Field type="password" label="Nouveau" value={pwdForm.next} onChange={(v) => setPwdForm({ ...pwdForm, next: v })} testid="pwd-next" required />
            <Field type="password" label="Confirmation" value={pwdForm.confirm} onChange={(v) => setPwdForm({ ...pwdForm, confirm: v })} testid="pwd-confirm" required />
          </div>
          {pwdErr && <p className="text-xs text-red-300">{pwdErr}</p>}
          <SaveBar saving={pwdSaving} message={pwdMsg} label="Mettre à jour" />
        </form>
      </Card>

      <div className="mt-8">
        <PushSettings />
      </div>
    </div>
  );
}
